import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import tinycolor from "tinycolor2";

export default {
    name: "TransactionCategoryDetail",
    components: {
        MainLayout,
        Loading,
    },
    data() {
        return {
            isLoading: false,
            noDataMsg: CONFIG.NO_DATA_EXIST,
            transactionCategory: {},
            CONFIG,
        };
    },
    computed: {
        categoryTypeLabel() {
            if (this.transactionCategory.category_type == null) {
                return "—";
            }
            if (this.transactionCategory.category_type === this.CONFIG.TRANSACTION_TYPE.INCOME) {
                return "Income";
            }
            if (this.transactionCategory.category_type === this.CONFIG.TRANSACTION_TYPE.EXPENSE) {
                return "Expense";
            }
            if (this.transactionCategory.category_type === this.CONFIG.TRANSACTION_TYPE.ASSET) {
                return "Asset";
            }
            if (this.transactionCategory.category_type === this.CONFIG.TRANSACTION_TYPE.INVESTMENT) {
                return "Investment";
            }
            return "—";
        },
        statusLabel() {
            if (this.transactionCategory.is_active == null) {
                return "—";
            }
            return Number(this.transactionCategory.is_active) === 1 ? "Active" : "Inactive";
        },
    },
    methods: {
        validColor(value) {
            const input = String(value ?? "").trim();
            if (!input) {
                return false;
            }

            const standardHexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
            if (!standardHexRegex.test(input)) {
                return false;
            }
        
            const color = tinycolor(input);
            if (!color.isValid()) {
                return false;
            }
        
            return color.toHexString();
        },
        getDetail() {
            const id = this.$route.params.id;
            this.isLoading = true;
            axios
                .get(`/transactionCategory/detail/${id}`)
                .then((res) => {
                    if (res.data) {
                        this.transactionCategory = res.data;
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.transactionCategory = {};
                    if (error.response?.status == 401) {
                        this.$store.commit("logout");
                        window.location.replace("login");
                    }
                    console.error("Error fetching transaction category info:", error);
                });
        },
        goToList() {
            this.$router.push({ name: "transactionCategoryList" });
        },
    },
    mounted() {
        this.isLoading = true;
        this.getDetail();
    },
};
